import { TaskAdditionalInfo } from '../task-additional-info.model';
import { WpPerson } from './wp-person.model';
import { WpReferral } from './wp-referral.model';

export class Task  {
constructor(
        public id?: number,
        public taskType?: string,
        public taskStatus?: string,
        public taskDueDt?: any,
        public programCd?: string,
        public taskStartDt?: any,
        public taskCompletionDt?: any,
        public assignedTo?: string,
        public assignedToInd?: string,
        public createdDate?: any,
        public lastModifiedBy?: string,
        public lastModifiedDate?: any,
        public wpReferral?: WpReferral,
        public wpPerson?: WpPerson,
        public statusDt?: any,
        public serviceCounty?: any,
        public recordVersion?:number,
        public parentTaskId?: number,
        public notes?: string,
        public assignedUser?: any,
        public assignedUserStr?: any,
        public subTaskType?: string,
        public otherType?: string,        
        public taskAdditionalInfo?: TaskAdditionalInfo,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/task.model.ts